import Seo from "@/components/Seo";
export default function Cookies() {
  return (
    <>
      <Seo title="Cookies" path="/politica-de-cookies" />
      <article className="wrap legal-page">
        <h1>Cookies</h1>
        <p className="legal-lead">
          Informații despre cookies și servicii externe.
        </p>
        <h2>Ce folosește site-ul</h2>
        <p>
          Site-ul nu setează cookies pentru analiză sau publicitate și nu
          stochează preferințe în browser. Fotografiile și fonturile se încarcă
          de pe serverul site-ului.
        </p>
        <h2>Servicii externe</h2>
        <p>
          WhatsApp și Google Maps se deschid numai când alegi linkurile lor.
          După deschidere, se aplică politicile serviciului extern. Nu încărcăm
          o hartă încorporată sau scripturi de analiză.
        </p>
      </article>
    </>
  );
}
